module.exports = __webpack_public_path__ + "static/img/resume-side-bar.0ce20de.png";